export default __webpack_public_path__ + "static/media/Chica-sucu-credicuotas 2.21b1b066.png";